/**
 * Reports Hub.
 *
 * Combines analytics, business insights, industry benchmarks, and the
 * what-if simulator into a single intelligence center. All reporting
 * and analysis tools in one place.
 */

import {
  BarChart3,
  FileText,
  FlaskConical,
  Lightbulb,
  Trophy,
} from "lucide-react";
import HubTabs from "@/components/ui/HubTabs";
import { useTabState } from "@/hooks/useTabState";
import AnalyticsPage from "@/pages/AnalyticsPage";
import ReportRunnerPage from "@/pages/ReportRunnerPage";
import InsightsPage from "@/pages/InsightsPage";
import BenchmarksPage from "@/pages/BenchmarksPage";
import WhatIfPage from "@/pages/WhatIfPage";

const tabs = [
  // First, and the default: the standard reports are what a dealer came here
  // for (FS-057). Analytics is the dashboard view of the same data.
  { key: "reports", label: "Reports", icon: FileText },
  { key: "analytics", label: "Analytics", icon: BarChart3 },
  { key: "insights", label: "Insights", icon: Lightbulb },
  { key: "benchmarks", label: "Benchmarks", icon: Trophy },
  { key: "what-if", label: "What-If", icon: FlaskConical },
];

function ReportsHub() {
  const [activeTab, setActiveTab] = useTabState("tab", "reports");

  return (
    <div className="page-wide space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-[var(--text-primary)]">
          Reports
        </h2>
        <p className="mt-1 text-sm text-[var(--text-secondary)]">
          Standard reports, analytics, insights, benchmarks and scenario
          modeling.
        </p>
      </div>

      <HubTabs tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />

      {activeTab === "reports" && <ReportRunnerPage />}
      {activeTab === "analytics" && <AnalyticsPage />}
      {activeTab === "insights" && <InsightsPage />}
      {activeTab === "benchmarks" && <BenchmarksPage />}
      {activeTab === "what-if" && <WhatIfPage />}
    </div>
  );
}

export default ReportsHub;
